import React from "react";
import ConteudoModel from "./model/ConteudoModel";
import AppState from "./model/AppState";
import QueryString from "query-string";
import MockData from "./model/MockData";
import Rodape from "./components/Rodape";
import RodapeConteudoContexto from "./components/RodapeConteudoContexto";
import SeletorLoja from "./components/SeletorLoja";
import GrupoProdutos from "./components/GrupoProdutos";
import PaginaTitulo from "./components/PaginaTitulo";
import WPBuscaDAO from "./dataAccess/WP/WPBuscaDAO";
import LogUtil from "./util/LogUtil";
import ProdutoModel from "./model/ProdutoModel";
import NavegadorUtil from "./util/NavegadorUtil";
import LojaModel from "./model/LojaModel";
import C5CarrinhoDAO from "./dataAccess/C5/C5CarrinhoDAO";
import Carregando from "./components/Carregando";
import { RouteComponentProps } from "react-router-dom";

interface IConteudoProps extends RouteComponentProps {}

type ConteudoState = {
  conteudo: ConteudoModel | null;
  carregando: boolean;
  concluido: boolean;
};

class Conteudo extends React.Component<IConteudoProps, ConteudoState> {
  constructor(props: IConteudoProps) {
    super(props);

    this.adicionarTodos = this.adicionarTodos.bind(this);

    this.state = {
      conteudo: null,
      carregando: true,
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Conteudo");
    let query: any;
    query = QueryString.parse(this.props.location.search);

    if (AppState.getMockData()) {
      this.setState({
        conteudo: MockData.getConteudo(query.conteudoId),
      });
    } else {
      WPBuscaDAO.getInstance()
        .getById(query.conteudoId, true)
        .then((r: ConteudoModel[]) => {
          this.setState({
            conteudo: r[0],
            carregando: false,
            concluido: true,
          });
        }).catch((err) => {
          this.setState({ carregando: false, concluido: true });
          LogUtil.logEvento('ErroCarregarConteudo', err);
          NavegadorUtil.alerta(this, `Erro ao carregar conteúdo`);
        });
    }
  }

  async adicionarTodos(): Promise<any> {
    LogUtil.logPage(`Compre tudo o que precisa`);
    
    const itensAdicionados: ProdutoModel[] = [];
    let erro: boolean = false;
    const { conteudo } = this.state;

    if (conteudo && conteudo.produtos) {
      const produtos: ProdutoModel[] = conteudo.produtos;
      produtos.map(async (p: ProdutoModel) => {
        let idx: number = 0;
        if (isNaN(p.quantidade)) {
          p.quantidade = 1;
        }

        let obs = "";
        // promocoes especificas
        const arrPromocoes = ['15012','15009','15007','15006'];
        if (arrPromocoes.includes(conteudo.conteudoId)) {
          obs = "1000000000007235";
        }

        while (idx++ < p.quantidade && !erro) {
          await AppState.addCarrinhoItem(p, obs)
            .then(() => {
              const adicionado:
                | ProdutoModel
                | undefined = itensAdicionados.find((i) => i.sku === p.sku);
              if (adicionado) {
                adicionado.quantidade++;
              } else {
                const prodClone: ProdutoModel = JSON.parse(JSON.stringify(p));
                itensAdicionados.push(prodClone);
                prodClone.quantidade = 1;
              }
            })
            .catch((ex) => {
              NavegadorUtil.alerta(
                this,
                `O item ${p.nome} não tem quantidade suficiente em estoque para adicionar todos os itens`
              );
            });
          NavegadorUtil.alerta(this, `Itens adicionados ao carrinho`);

          const loja: LojaModel | null = AppState.getLojaSelecionada();
          if (loja) {
            this.setState({ carregando: true });
            C5CarrinhoDAO.getInstance()
              .updateCarrinho(loja)
              .then(() => {
                this.forceUpdate();
                this.setState({ carregando: false });
              });
          }
        }
        return p;
      });

      this.forceUpdate();
    }
  }

  render(): any {
    const { conteudo, carregando, concluido } = this.state;

    if (!conteudo) {
      return (
        <section className="content white-bg">
          <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
          <PaginaTitulo titulo="Carregando ..."></PaginaTitulo>
          <Rodape parent={this} ativo=""></Rodape>
          <Carregando exibir={true} concluido={concluido} />
        </section>
      );
    }

    return (
      <section className="content white-bg">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        {conteudo.imagem && (
          <div className="main-image">
            <img src={conteudo.imagem} alt={conteudo.nome} />
          </div>
        )}
        <PaginaTitulo titulo={conteudo.nome}></PaginaTitulo>
        <div className="main-content">
          <div
            dangerouslySetInnerHTML={{
              __html: conteudo.resumo ? conteudo.resumo : "<div></div>",
            }}
          ></div>
          <div
            dangerouslySetInnerHTML={{
              __html: conteudo.conteudo ? conteudo.conteudo : "<div></div>",
            }}
          ></div>
          {conteudo.ingredientes && (
            <>
              <p className="title">Ingredientes</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: conteudo.ingredientes ? conteudo.ingredientes : "",
                }}
              />
            </>
          )}
          {conteudo.preparo && (
            <>
              <p className="title">Modo de preparo</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: conteudo.preparo ? conteudo.preparo : "",
                }}
              />
            </>
          )}
          {conteudo.tempo_de_preparo && (
            <>
              <p className="title">Tempo de preparo</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: conteudo.tempo_de_preparo
                    ? conteudo.tempo_de_preparo
                    : "",
                }}
              />
            </>
          )}
          {conteudo.dificuldade && (
            <>
              <p className="title">Dificuldade</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: conteudo.dificuldade ? conteudo.dificuldade : "",
                }}
              />
            </>
          )}
          {conteudo.porcoes && (
            <>
              <p className="title">Porções</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: conteudo.porcoes ? conteudo.porcoes : "",
                }}
              />
            </>
          )}
        </div>
        {conteudo.produtos && conteudo.produtos.length > 0 && (
          <GrupoProdutos
            titulo="COMPRE TUDO QUE PRECISA"
            items={conteudo.produtos}
            adicionarTodos={this.adicionarTodos}
            verMais={false}
            parent={this}
          />
        )}
        <RodapeConteudoContexto
          conteudo={conteudo}
          parent={this}
        ></RodapeConteudoContexto>
        <Rodape parent={this} ativo=""></Rodape>
        <Carregando exibir={carregando} concluido={concluido} />
      </section>
    );
  }
}

export default Conteudo;
